import { IoLibraryOutline ,IoCarSportOutline } from "react-icons/io5";
import { PiSecurityCameraDuotone ,PiWarehouseLight ,PiSwimmingPoolLight  } from "react-icons/pi";
import { LiaBedSolid } from "react-icons/lia";
import { TbPlayBasketball } from "react-icons/tb";
import { CiMedicalCase } from "react-icons/ci";
import { MdOutlineRollerSkating } from "react-icons/md";
import { IoCafeOutline } from "react-icons/io5";
import { GiButterflyFlower } from "react-icons/gi";
import { GiTheaterCurtains } from "react-icons/gi";
import { CgGym } from "react-icons/cg";
import { GiMeditation } from "react-icons/gi";
import { SiClubhouse } from "react-icons/si";


const AmenitiesData = [
    {
        id: 1,
        title: "Meditation Pod",
        cover: <GiMeditation />,
        color:"white"
    },
    {
        id: 2,
        title: "Amphitheatre",
        cover: <GiTheaterCurtains />,
        color:"#ddecd5"
    },
    {
        id: 3,
        title: "Gymnasium",
        cover: <CgGym />,
        color:"white"
    },
    {
        id: 4,
        title: "Clubhouse",
        cover: <SiClubhouse   />,
        color:"#ddecd5"
    },
    {
        id: 3,
        title: "Step Garden",
        cover: <GiButterflyFlower />,
        color:"white"
    },
    {
        id: 5,
        title: "Swimming Pool",
        cover: <PiSwimmingPoolLight  />,
        color:"#ddecd5"
    },
    {
        id: 6,
        title: "Cafeteria",
        cover: <IoCafeOutline />,
        color:"white"
    },
    {
        id: 7,
        title: "Kids Play",
        cover: <TbPlayBasketball />,
        color:"#ddecd5"
    },
    {
        id: 8,
        title: "Skating Rink",
        cover: <MdOutlineRollerSkating />,
        color:"white"
    },
    {
        id: 7,
        title: "Medical Center",
        cover: <CiMedicalCase />,
        color:"#ddecd5"
    },
]

export default AmenitiesData